import MileageDownloadParams, {
  MileageDownloadParamsOrder,
} from "../../../../common/services/mileage/download/mileage-download-params";
import MileageListingActionData from "./types/mileage-listing-action-data";
import MileageListingSortKey from "./types/mileage-listing-sort-key";

const createOrder = (
  sortKey: MileageListingSortKey,
): MileageDownloadParamsOrder | undefined => {
  switch (sortKey) {
    case MileageListingSortKey.CARD_NO_ASC:
      return MileageDownloadParamsOrder.CARD_NO_ASC;
    case MileageListingSortKey.CARD_NO_DESC:
      return MileageDownloadParamsOrder.CARD_NO_DESC;
    case MileageListingSortKey.CARGO_COMPANY_NAME_ASC:
      return MileageDownloadParamsOrder.CARGO_COMPANY_NAME_ASC;
    case MileageListingSortKey.CARGO_COMPANY_NAME_DESC:
      return MileageDownloadParamsOrder.CARGO_COMPANY_NAME_DESC;
    case MileageListingSortKey.DATE_ASC:
      return MileageDownloadParamsOrder.DATE_ASC;
    case MileageListingSortKey.DATE_DESC:
      return MileageDownloadParamsOrder.DATE_DESC;
    case MileageListingSortKey.DISTANCE_ASC:
      return MileageDownloadParamsOrder.DISTANCE_ASC;
    case MileageListingSortKey.DISTANCE_DESC:
      return MileageDownloadParamsOrder.DISTANCE_DESC;
    case MileageListingSortKey.HUMAN_ID_ASC:
      return MileageDownloadParamsOrder.HUMAN_ID_ASC;
    case MileageListingSortKey.HUMAN_ID_DESC:
      return MileageDownloadParamsOrder.HUMAN_ID_DESC;
    case MileageListingSortKey.WORKER_LAST_NAME_ASC:
      return MileageDownloadParamsOrder.WORKER_LAST_NAME_ASC;
    case MileageListingSortKey.WORKER_LAST_NAME_DESC:
      return MileageDownloadParamsOrder.WORKER_LAST_NAME_DESC;
    case MileageListingSortKey.WORKER_NAME_ASC:
      return MileageDownloadParamsOrder.WORKER_NAME_ASC;
    case MileageListingSortKey.WORKER_NAME_DESC:
      return MileageDownloadParamsOrder.WORKER_NAME_DESC;
    default:
      return undefined;
  }
};

const create = (
  actionDataList: MileageListingActionData[],
  sortKey: MileageListingSortKey,
): MileageDownloadParams => {
  return {
    mileageUuids: actionDataList.map((actionData) => actionData.mileageUuid),
    order: createOrder(sortKey),
  };
};

const mileageListingDownloadCSVParamsFactory = {
  create,
};

export default mileageListingDownloadCSVParamsFactory;
